import {
	ACTIVATE_PAYMENT,
	ERROR_ACTIVATE_PAYMENT
} from '../../../constants';

const callbackPaymentState = {
	meta: null,
	paid: false,
	redirectUrl: ''
};

export default function callbackPaymentReducer(state = callbackPaymentState, action) {
	switch (action.type) {
		case ACTIVATE_PAYMENT:
			return Object.assign({}, state, {
				meta: action.meta,
				paid: true,
				redirectUrl: action.redirect_url
			});
		case ERROR_ACTIVATE_PAYMENT:
			return Object.assign({}, state, {
				meta: action.meta,
				paid: false,
				redirectUrl: action.redirect_url
			});

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/containers/callback-payment-page/reducers/index.js